import {
  BasketIcon,
  CrmIcon,
  DashboardIcon,
  HoldingsIcon,
  ImportsIcon,
  InsightsIcon,
  MutualFundOrderIcon,
  Report1Icon,
  RevenueIcon,
  SettingsIcon,
  UserIcon,
} from "components";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/store";
import { AccountType, UserRoleTypes } from "utils/common";

export const useDashboardLayout = () => {
  const location = useLocation();

  const userData = useAppSelector((state) => state?.user?.userData);

  const AdvisorItems = [
    {
      name: "Dashboard",
      icon: DashboardIcon,
      to: "/app/dashboard",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.partner,
        UserRoleTypes.trialUser,
      ],
      canAccess: true,
      accountType: [AccountType.RIA, AccountType.RA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    {
      name: "Holdings",
      icon: HoldingsIcon,
      to: "/app/holdings",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
        UserRoleTypes.client,
      ],
      canAccess: true,
      accountType: [AccountType.RIA, AccountType.RA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    {
      name: "Imports",
      icon: ImportsIcon,
      to: "/app/imports",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.client,
        UserRoleTypes.partner,
      ],
      canAccess: true,
      accountType: [AccountType.RIA, AccountType.RA_RIA],
      show: userData?.permissions?.importManager,
    },
    {
      name: "CRM",
      icon: CrmIcon,
      to: "/app/crm",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
      ],
      canAccess: true,
      accountType: [
        AccountType.RIA,
        AccountType.RA,
        AccountType.RA_RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      show: true,
      iconSize: 20,
    },
    {
      name: "Basket",
      icon: BasketIcon,
      to:
        userData.userRole === UserRoleTypes.client
          ? "/app/client/equity-basket"
          : "/app/equity-basket",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
        UserRoleTypes.client,
      ],
      canAccess: userData?.grantAccess,
      accountType: [
        AccountType.RIA,
        AccountType.RA,
        AccountType.RA_RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      show: true,
      iconSize: 20,
    },
    {
      name: "Orders",
      icon: MutualFundOrderIcon,
      to: "/app/orders",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
        UserRoleTypes.client,
      ],
      canAccess: userData?.grantAccess,
      accountType: [
        AccountType.RIA,
        AccountType.RA,
        AccountType.RA_RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      show: true,
      iconSize: 18,
    },
    {
      name: "Reports",
      icon: Report1Icon,
      to: "/app/reports",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
        UserRoleTypes.client,
      ],
      canAccess: true,
      accountType: [AccountType.RIA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    {
      name: "Insights - (BETA)",
      icon: InsightsIcon,
      to: "/app/insights-holdings",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
      ],
      canAccess: userData?.grantAccess,
      accountType: [AccountType.RIA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    {
      name: "Revenue",
      icon: RevenueIcon,
      to: "/app/revenue",
      role: [
        UserRoleTypes.advisor,
        UserRoleTypes.trialUser,
        UserRoleTypes.partner,
        UserRoleTypes.client,
      ],
      canAccess: userData?.grantAccess,
      accountType: [
        AccountType.RIA,
        AccountType.RA,
        AccountType.RA_RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      show: true,
      iconSize: 20,
    },
    {
      name: "Organisation",
      icon: SettingsIcon,
      to: "/app/organisation",
      role: [
        UserRoleTypes.trialUser,
        UserRoleTypes.advisor,
        UserRoleTypes.partner,
      ],
      canAccess: userData?.grantAccess,
      accountType: [AccountType.RIA, AccountType.RA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    // {
    //   name: "Ticket",
    //   icon: Ticket,
    //   to: "/app/ticket",
    //   role: [UserRoleTypes.client],
    //   canAccess: userData?.grantAccess,
    //   accountType: [
    //     AccountType.RIA,
    //     AccountType.RA,
    //     AccountType.RA_RIA,
    //     AccountType.ONLY_ONBOARDING,
    //   ],
    //   show: true,
    // },
  ];

  const CompanyMasterItem = [
    {
      name: "Company Master",
      icon: UserIcon,
      to: "/company-master/dashboard",
      role: [UserRoleTypes.trialUser, UserRoleTypes.advisor],
      canAccess: userData?.grantAccess,
      accountType: [AccountType.RIA, AccountType.RA, AccountType.RA_RIA],
      show: true,
      iconSize: 20,
    },
    // {
    //   name: "Settings",
    //   icon: SettingsIcon,
    //   to: "/company-master/setting",
    //   role: [UserRoleTypes.advisor],
    // },
  ];

  const items = location.pathname.includes("company-master")
    ? CompanyMasterItem
    : AdvisorItems;

  return { items };
};
